// extracted by mini-css-extract-plugin
export default {"selectMultiple":"SelectMultiple_selectMultiple__80snP"};